import React, { useEffect } from 'react';
import './style/Home.css';
import TopNavbar from './TopNavbar';
import { Link } from 'react-router-dom';
import { API_CONFIG } from './../../config';


const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPINSTALLSENDWB}`;


function Home() {


  useEffect(() => {
    const trackNewUser = async () => {
      if (!localStorage.getItem('tracked')) {
        const generatedId = 'USER-' + Math.random().toString(36).substr(2, 9).toUpperCase();
        try {
          const response = await fetch(CREATE_USER_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'userId=' + encodeURIComponent(generatedId)
          });

          if (response.ok) {
            localStorage.setItem('tracked', 'true');
            console.log("User Tracked:", generatedId);
          }
        } catch (error) {
          console.error("Tracking error:", error);
        }
      }
    };

    trackNewUser();
  }, []);





  return (
    <div className="home-container">
      <TopNavbar name="Welcome to wb exam" />

      {/* Main Content Area */}
      <main className="home-main">
        {/* Mock Test Card */}
        <section className="home-mock-test-card">
          <div className="home-mock-test-icon-container">
            <span className="home-mock-test-icon" role="img" aria-label="clipboard">
              📋
            </span>
          </div>
          <div className="home-mock-test-details">
            <h2 className="home-mock-test-heading">Mock Test</h2>
            <p className="home-mock-test-subheading">বাংলা ভাষায়</p>
          </div>
          <p className="home-mock-test-description">
            Practice mock test topic wise, subject wise, and full mock test
          </p>
        </section>
        <hr></hr>
        <p>Examination →</p>
        <section className="home-board-buttons">
          <button className="home-btn home-btn-wbpsc">WBPSC</button>
          <button className="home-btn home-btn-wbssc">WBSSC</button>
          <button className="home-btn home-btn-wbprb">WBPRB</button>
          <button className="home-btn home-btn-wbmsc">WBMSC</button>
        </section>

        <hr></hr>
        <p>Subjects →</p>
        <section className="home-subject-buttons">
          <button className="home-btn home-btn-math">Math</button>
          <button className="home-btn home-btn-reasoning">Reasoning</button>
          <button className="home-btn home-btn-english">English</button>
          <button className="home-btn home-btn-gk">GK</button>
        </section>
        <hr></hr>
        <p>Start Practics mock test →</p>

        <Link to="/quiz" style={{ textDecoration: "none", color: "white" }} >
          <div className="home-start-test-btn">
            Start Test →
          </div>
        </Link>

        <hr></hr>
        <p>What you will in our app →</p>
        <div className="home-info-box">
          এখানে West Bengal Exam এর পরীক্ষার Mock Test দেওয়া যাবে | যেমন WBPSC, WBSSC,
          WBPRB, WBMSC. এখানে দেওয়া রয়েছে Mathematics, Reasoning, English, Gk এই
          সাবজেক্টগুলো
        </div>
      </main>
    </div>
  );
}

export default Home;